namespace advisorop.factories {
    `use strict`;

    export class MeetingHubSignalR {
        private connection: signalR.HubConnection;
        private callbacks = new Map<string,Map<string, any>>();

        constructor() {
            this.connection = new signalR.HubConnectionBuilder().withUrl("/meeting-hub-documents-hub").build();
            this.connection.on('NotifyDocumentChanges', (meetingGuid) => {
                if (this.callbacks.has(meetingGuid)) {
                    this.callbacks.get(meetingGuid).forEach((callback, key) => {
                        callback(meetingGuid);
                    })
                }
                if (this.callbacks.has("All")) {
                    this.callbacks.get("All").forEach((callback, key) => {
                        callback(meetingGuid);
                    })
                }
            })
        }
         
        public Start(): Promise<void> {
            return this.connection.start();
        }

        public Group(group: string) {
            this.connection.send('joinGroup', group).then(() => {
                console.log('JoinGroup');
            }).catch(err => {
                console.log(err);
            });
        }

        public GetConnectionState(): signalR.HubConnectionState {
            return this.connection.state;
        }

        public OnDocumentChanges(meetingGuid: string, callback: any): string{
            var key = Date.now().toString();
            if (callback) {
                if (this.callbacks.has(meetingGuid)) {
                    this.callbacks.get(meetingGuid).set(key, callback);
                } else {
                    var newCallbackMap = new Map<string, any>();
                    newCallbackMap.set(key, callback);
                    this.callbacks.set(meetingGuid, newCallbackMap);
                }
            }
            return key;
        }

        public RemoveOnDocumentChanges(meetingGuid: string, key: string) {
            if (this.callbacks.has(meetingGuid)) {
                this.callbacks.get(meetingGuid).delete(key)
            }
        }

        static factory() {
            return () => new MeetingHubSignalR();
        }
    }

    angular.module(Constants.ADVOP_SERVICES).factory("MeetingHubSignalR", MeetingHubSignalR.factory());
}